module.exports = __webpack_public_path__ + "img/project1.c44422b8.jpeg";